import { AuthorizationGroupDto } from '../components/Combobox/AuthorizationGroupCombobox'
import useGlobalContext from './useGlobalContext'
import { useMemo } from 'react'

type ReturnProps = {
    loaded: boolean
    authorizationGroups: AuthorizationGroupDto[]
}

export default function useAuthorizationGroups(): ReturnProps {
    const { entities, loaded } = useGlobalContext('authorizationGroups')

    const authorizationGroups: AuthorizationGroupDto[] = useMemo(
        () => entities?.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase())) || [],
        [entities],
    )

    return { loaded, authorizationGroups }
}
